import CloseIcon from 'icon/close'
import React from 'react'

function Modal({ open, onClose, children, showHeader, title }) {
  return (
    <div>
      {open && (
        <div
          onClick={onClose}
          className='fixed inset-0 overflow-y-auto overflow-x-hidden z-50 flex items-center justify-center bg-black bg-opacity-50'
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className='relative bg-white rounded-lg shadow'
          >
            {showHeader && (
              <div className='flex items-center justify-between p-3 md:p-5 border-b rounded-t'>
                <h3 className='text-xl font-semibold text-gray-900 '>
                  {title}
                </h3>
                <button
                  onClick={onClose}
                  type='button'
                  className='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center'
                >
                  <CloseIcon />
                  <span className='sr-only'>Close modal</span>
                </button>
              </div>
            )}
            {children}
          </div>
        </div>
      )}
    </div>
  )
}

export default Modal
